<template>
    <div class="card featured-listing-business" :class="business.featured === 'yes' ? 'featured': '' ">
        <!-- Router-link wrapping only the top section -->
        <router-link :to="{ name: 'single-business', params: { slug: business.slug } }"
                class="nav-link d-flex d-lg-block flex-wrap">
            <img :src="getImagePath(business.business_logo)" class="custom-mobile-w card-img-top"
                width="320" height="180" loading="lazy" decoding="async"
                :alt="`${business.business_name} Logo`">
            <div class="card-body">
                <h3 class="card-title mb-2">
                    {{ business.business_name }}
                   <span
    v-if="business.verified === 'yes'"
    class="verified"
    role="img"
    aria-label="Verified business">
    <i class="fas fa-check-circle" aria-hidden="true"></i>
</span>
                    <!-- Manage By Bizrar -->
                    <span class="manage-by-bizrar" v-if="business.manage_by_bizrar == 'yes'" role="img" aria-label="Business managed by bizrar">
                        <i class="fas fa-search me-0 me-md-1" aria-hidden="true"></i> <span class="d-none d-md-block">Managed by Bizrar</span>
                    </span>
                </h3>
         
                <p class="card-text m-0" aria-label="Business address">
                    <i class="fas fa-map-marker-alt mr-1" aria-hidden="true"></i>
                    {{ business.address_line_1 }}
                </p>
                <div class="row mt-1">
                    <div class="col-12 pl-0">
                        <div class="ratings" role="img" 
                            :aria-label="business.rating.total_reviews > 0
                            ? `Rated ${business.rating.average_rating} out of 5 stars`
                            : 'No ratings yet'" >
                        <Rating :rating="business.rating.average_rating"/>
                        </div>
                        <span class="reviews">
                            {{ business.rating.average_rating }}
                            (<u>{{ business.rating.total_reviews }} reviews</u>)
                        </span>
                    </div>
                </div>
                       <div class="label-slot">

               <span
    v-for="label in business.labels.slice(0, 2)"
    :key="label.id"
    class="badge custom-bg-secondary mb-2"
    style="margin-right: 4px">
    {{ label.label_name }}
</span>
<span 
    v-if="business.labels.length > 2"
    class="badge badge-more mb-2">
    +{{ business.labels.length - 2 }} more
</span>
</div>  
            </div>
        </router-link>
        <!-- Section outside router-link -->
        <hr class="my-1 my-md-3">
        <div class="row align-items-center p-2 p-md-3">
            <div class="col col-md-7 pl-0">
                <router-link :to="{ name: 'single-business', params: { slug: business.slug } }"
                        :aria-label="`View details for ${business.business_name}`"
                        class="nav-link" style="display:inline-block;">
                    <button class="button nevy-button">View Details</button>
                </router-link>
            </div>
            <div class="col col-md-5 text-end">
                <button class="favBrand btn p-0" @click="fetchFavouriteProductWithParams" 
                    style=""
                    :aria-label="business.is_favorite 
                        ? `Remove ${business.business_name} from favorites`
                        : `Add ${business.business_name} to favorites`"
                    :aria-pressed="business?.is_favorite?.toString()" >
                    <i v-if="FavouriteLoading" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                    <i v-else
                       :class="['far', 'fa-heart', { 'fas': business.is_favorite, 'text-danger': business.is_favorite }, 'pe-4', 'shadow', 'ms-3']" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import Rating from "./include/Rating.vue";
import {mapActions, mapState} from "vuex";
import axios from "axios";
import {ref, watch} from 'vue';
import {toast} from 'vue3-toastify';
import { getImagePath } from "../utils/helpers";

export default {
    components: {
        Rating,
    },
    name: "Business Card",
    props: ['business'],
    data() {
        return {
            FavouriteLoading :false,
        };
    },
    methods: {
        ...mapActions('business', ['fetchFavouriteProduct','fetchFavItemCount','decrementFavItemsCount','incrementFavItemsCount']),
        getImagePath,
        fetchFavouriteProductWithParams() {
            const token = localStorage.getItem('token');
            if (!token) {
                toast.error('You need to log in to add products to your favorites.');
                return;
            }

            if (this.business && this.business.id) {
                // Start the loader only when the action is being performed
                this.FavouriteLoading = true;

                this.fetchFavouriteProduct({ business_id: this.business.id })
                    .then(response => {
                        this.FavouriteLoading = false; // Stop loader

                        if (response.success === 'Unlike') {
                            toast.warn('Business removed from favorite');
                            this.decrementFavItemsCount();
                            this.business.is_favorite = false;
                        } else if (response.success === 'Like Done') {
                            toast.success('Business added in favorite');
                            this.incrementFavItemsCount();
                            this.business.is_favorite = true;
                        } else {
                            toast.error('Something went wrong, please try again');
                        }
                    })
                    .catch(error => {
                        this.FavouriteLoading = false; // Stop loader on error
                        console.error('Error fetching favorite product:', error);
                        // toast.error('Error while processing your request');
                    });
            } else {
                console.error('Business ID is not available');
            }
        }


    },
    computed: {
        ...mapState('business', ['IsFavourite','FavItemsCount'])
    }
};
</script>
<style scoped>
/* Card must have fixed width - let carousel control it */
.featured-listing-business {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%; /* fill carousel slide */
    min-width: 0; /* prevent overflow expanding card */
}

/* Image fixed height */
.card-img-top {
    width: 100%;
    height: 180px;
    object-fit: cover;
}

/* Card body fixed layout */
.featured-listing-business .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    min-width: 0; /* prevent text from expanding card */
}

/* Title fixed height */
.card-title {
    font-size: 1rem;
    height: 48px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word; /* prevent long words expanding card */
}

/* Address fixed height */
.card-text {
    height: 40px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 13px;
    word-break: break-word;
    margin-top: 4px;
}

/* Ratings fixed height */
.row.mt-1 {
    height: 45px;
    overflow: hidden;
    margin: 4px 0;
}

/* Labels fixed height */
.label-slot {
    height: 28px;
    min-height: 28px;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 4px;
    margin-top: 8px;
}

/* Footer fixed height — THIS is what fixes the shifting footer */
.card > .row.align-items-center {
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    flex-shrink: 0;
    padding: 0 12px !important;
}
.featured-listing-business {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.featured-listing-business .card-body {
    flex: 1;
}

/* +N more badge styling */
.badge-more {
    background-color: #fff3ee;
    color: #ff5e14;
    border: 1px solid #ff5e14;
    font-size: 0.75rem;
    border-radius: 4px;
}
@media (max-width: 992px) {
    .custom-mobile-w {
        width: 100% !important;
        padding: 1rem;
        min-width: 150px;
    }
    .nevy-button {
        font-size: 14px !important;
    }
    .nevy-button {
        padding: 11px 20px;
    }
    .card-body {padding-left: 0 !important;}
}
@media (max-width: 768px) {
    .custom-mobile-w {
        padding: 0.6rem !important;
    }
    .card-body {padding-left: 0 !important;padding: 0.6rem !important}
    /* .card-title {
        font-size: 16px !important;
    } */
    .card-text {
        font-size: 10px;
    }
    .card-text i {
        margin: 0;
        font-size: 10px;
    }
    .star {
        line-height: 15px !important;
        font-size: 12px !important;
    }
    :deep(.ratings span .star) {
        font-size: 12px !important;
        line-height: 16px;
    }
    .reviews { font-size: 12px !important; }
    .reviews a { font-size: 12px !important; }
    .reviews a u { font-size: 12px !important; }
    .shadow {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 13px !important;
        width: 32px !important;
        height: 32px !important;
    }
    .nevy-button {
        font-size: 12px !important;
        min-width: 100px !important;
        padding: 0 !important;
    }
    .verified {font-size: 10px !important; padding: 6px !important;}
    .verified i {font-size: inherit !important}
    .manage-by-bizrar {font-size: 10px !important; padding: 6px !important;}
    .manage-by-bizrar i {font-size: inherit !important}
    .featured-listing-business.featured::before {
        top: 13px !important;
        right: -49px !important;
        font-size: 8px !important;
        padding: 2px 50px !important;
    }
}
.featured-listing-business.featured {
    border: 0.3px solid #fd7c3f;
    box-shadow: 0 0 4px rgba(253, 124, 63, 0.3);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}
.featured-listing-business.featured::before {
    content: "FEATURED";
    position: absolute;
    top: 20px;
    right: -44px;
    background: #fd7c3f;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 50px;
    transform: rotate(45deg);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.featured-listing-business.featured:hover {
    box-shadow: 0 0 10px rgba(253, 124, 63, 0.6);
}
.ratings { display: inline-block; }
.card-title { font-size: 1.5rem; }
.nevy-button { padding:8px 16px;border-radius: 8px !important; }
.btn {
    border:none !important;
    outline:none !important;
    box-shadow: none !important;
}
</style>
